<template>
  <div>
    <img
      src="/public/warranty/warranty_guarantee.png"
      class="hidden w-full h-full bg-no-repeat bg-cover md:block md:bg-center"
      alt=""
    />
    <img
      src="/public/warranty/warranty_guarantee_mobile.png"
      class="block w-full h-full bg-no-repeat bg-cover md:hidden md:bg-center"
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: "HalfBoxLayout",
};
</script>
<style>
.guarantee {
  background-image: url("@/public/warranty/warranty_guarantee.png");
  @apply bg-cover md:block  w-full h-[900px] md:bg-center bg-no-repeat;
}

.guarantee-mobile {
  background-image: url("@/public/warranty/warranty_guarantee_mobile.png");
  @apply bg-cover md:block  w-full h-full md:bg-center bg-no-repeat;
}
</style>
